import { CInputGroup, CInputGroupText, CSwitch } from '@coreui/react';
import * as React from 'react';
import { ICultureInfo } from '../../abstraction/ICultureInfos';
import { AppLabels } from '../../core/AppLabels';
import { KLoginConfInput } from './KLoginConfInput';

interface IProps {
    culture: ICultureInfo;
    onChange: (ctrl: ICultureInfo) => void;
}

interface IState {
    isActive: boolean;
}

// Panel contenant les paramètres relatifs à une langue 
export class KLoginConfTabPanel extends React.Component<IProps, IState> {
    public constructor(props: any) {
        super(props);

        this.state = {
            isActive: this.props.culture.active
        };
    }

    onChangeTitle = (value: string) => {
        this.props.culture.labels.Login_Title = value;
        this.props.onChange(this.props.culture);
    }

    onChangeLogin = (value: string) => {
        this.props.culture.labels.Login_Login = value;
        this.props.onChange(this.props.culture);
    }

    onChangePassword = (value: string) => {
        this.props.culture.labels.Login_Password = value;
        this.props.onChange(this.props.culture);
    }

    onChangeSubmit = (value: string) => {
        this.props.culture.labels.Login_Submit = value;
        this.props.onChange(this.props.culture);
    }

    onClick = (event) => {
        this.props.culture.active = !this.state.isActive;
        this.setState({ isActive: this.props.culture.active })
        this.props.onChange(this.props.culture);
    }

    render() {
        return (
            <div className="TabMenuPanel" id={"_" + this.props.culture.code} >
                <CInputGroup className="activePanel" size="sm" >
                    <CInputGroupText >
                        <CSwitch id={"act" + this.props.culture.code} onChange={this.onClick} checked={this.state.isActive} type='switch' onClick={this.onClick} label={AppLabels.configActiveLanguage} />
                    </CInputGroupText>
                </CInputGroup>

                <KLoginConfInput onChange={this.onChangeTitle} title="Title" label={this.props.culture.labels.Login_Title} ></KLoginConfInput>
                <KLoginConfInput onChange={this.onChangeLogin} title="Login" label={this.props.culture.labels.Login_Login} ></KLoginConfInput>
                <KLoginConfInput onChange={this.onChangePassword} title="Password" label={this.props.culture.labels.Login_Password} ></KLoginConfInput>
                <KLoginConfInput onChange={this.onChangeSubmit} title="Submit" label={this.props.culture.labels.Login_Submit} ></KLoginConfInput>
            </div>
        )
    }
}